import { callFunctionSafe } from "src/firebase/functions";
import { baseService } from "src/store/base.store";

export type AdminBroadcastContent = {
  subject: string;
  title: string;
  bodyHtml: string;
  preheader?: string;
  label?: string;
  ctaText?: string;
  ctaUrl?: string;
  language?: string;
  direction?: "ltr" | "rtl";
};

export type SendAdminBroadcastEmailRequest = {
  userIds: string[];
  content: AdminBroadcastContent;
};

export type SendAdminBroadcastEmailResponse = {
  success: true;
  requestedRecipientCount: number;
  triggerId: string | number;
};

const adminEmailService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    sendAdminBroadcastEmail: builder.mutation<
      SendAdminBroadcastEmailResponse,
      SendAdminBroadcastEmailRequest
    >({
      queryFn: async (payload) => {
        try {
          const response = await callFunctionSafe<SendAdminBroadcastEmailResponse>(
            "sendAdminBroadcastEmail",
            payload
          );

          if ("data" in response) return { data: response.data };

          return {
            error: {
              status: 500,
              data: response.error
            }
          };
        } catch (error) {
          return {
            error: {
              status: 500,
              data: error instanceof Error ? error.message : "Could not send the email"
            }
          };
        }
      }
    })
  })
});

export const { useSendAdminBroadcastEmailMutation } = adminEmailService;
